//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { StudentBillingProfileInputItem } from './StudentBillingProfileInputItem';

export class BillingProfileInputItem extends StudentBillingProfileInputItem {
    StudentID: string | null = null;

    constructor(initializer?: Partial<BillingProfileInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "BillingProfileInputItem";
}
